import gql from "graphql-tag";

export default gql`
	mutation changePassword($password: String!, $new_password: String!) {
		changePassword(password: $password, newPassword: $new_password) {
			success
		}
	}
`;
